import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, googleProvider } from '../config/firebase';
import { signInWithPopup } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import './AdminLogin.css';

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Mevcut session kontrolü
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const isAdmin = await checkAdminStatus(user.email);
        if (isAdmin) {
          navigate('/admin/dashboard');
        }
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const checkAdminStatus = async (userEmail) => {
    try {
      // Email'i lowercase'e çevir (Firestore document ID case-sensitive)
      const emailLower = userEmail.toLowerCase().trim();
      
      console.log('Checking admin status for:', emailLower);
      
      // Firestore'dan admin kontrolü
      const adminDoc = await getDoc(doc(db, 'admins', emailLower));
      
      console.log('Admin doc exists:', adminDoc.exists());
      if (adminDoc.exists()) {
        const data = adminDoc.data();
        console.log('Admin data:', data);
        return data.isActive === true;
      }
      
      console.log('Admin doc not found');
      return false;
    } catch (err) {
      console.error('Admin check error:', err);
      return false;
    }
  };

  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      setError('');

      // Google ile giriş yap
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      console.log('User logged in:', user.email);

      // Admin kontrolü
      const isAdmin = await checkAdminStatus(user.email);
      
      console.log('Is admin:', isAdmin);
      
      if (!isAdmin) {
        await auth.signOut();
        throw new Error('Bu hesap admin yetkisine sahip değil!');
      }

      // Başarılı giriş
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Google ile giriş yapılırken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-login-header">
          <h1>🔐 Admin Paneli</h1>
          <p>Elit IPTV Yönetim Sistemi</p>
          <p className="subtitle">Google hesabınızla giriş yapın</p>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="login-options">
          <button
            onClick={handleGoogleLogin}
            disabled={loading}
            className="btn-google-login"
          >
            {loading ? (
              <>⏳ Yükleniyor...</>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Google ile Giriş Yap
              </>
            )}
          </button>
        </div>

        <div className="login-info">
          <p>⚠️ Sadece yetkili admin hesapları giriş yapabilir.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
